import { render, staticRenderFns } from "./PixKeysPane.vue?vue&type=template&id=708e6f6c&scoped=true"
import script from "./PixKeysPane.vue?vue&type=script&lang=js"
export * from "./PixKeysPane.vue?vue&type=script&lang=js"
import style0 from "./PixKeysPane.vue?vue&type=style&index=0&id=708e6f6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e6f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708e6f6c')) {
      api.createRecord('708e6f6c', component.options)
    } else {
      api.reload('708e6f6c', component.options)
    }
    module.hot.accept("./PixKeysPane.vue?vue&type=template&id=708e6f6c&scoped=true", function () {
      api.rerender('708e6f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/PixKeysPane.vue"
export default component.exports